/* global $ */

const $form = $('.js-webshop-form');

const webshopForm = {
  initialize() {
    if (!$form.length) {
      return;
    }

    $form.on('change', '.js-product input[type="checkbox"]', () => {
      this.checkInputVisibility();
    });

    this.checkInputVisibility();
  },

  checkInputVisibility() {
    const products = $form.find('.js-product').toArray();

    products.forEach((product) => {
      const checkbox = product.querySelector('input[type="checkbox"]');
      const input = product.querySelector('.js-product-input');

      if (input) {
        input[checkbox.checked ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');
      }
    });
  },
};

export default webshopForm;
